<template>
  <span class="crm-phone-field" :class="[`is-${status}`]">
    <span v-if="prefix" class="crm-phone-prefix">{{ prefix }}</span>
    <span class="crm-phone-text">{{ displayText }}</span>
    <el-tooltip :content="tooltipText" placement="top">
      <button
        type="button"
        class="crm-phone-button"
        :class="[`is-${status}`]"
        @click.stop="handleClick"
      >
        <i :class="buttonIcon"></i>
      </button>
    </el-tooltip>
  </span>
</template>

<script>
export default {
  name: "CrmPhoneField",
  props: {
    phone: {
      type: [String, Number],
      default: "",
    },
    status: {
      type: String,
      default: "pending",
    },
    prefix: {
      type: String,
      default: "",
    },
  },
  computed: {
    displayText() {
      return this.phone || "未填写";
    },
    buttonIcon() {
      return this.status === "dialing"
        ? "el-icon-loading"
        : "el-icon-phone-outline";
    },
    tooltipText() {
      const textMap = {
        pending:
          "拨号功能预留中，后续将支持网页点击后由已登录手机 App 自动调起拨号。",
        offline: "手机 App 未在线，当前无法发起拨号。",
        ready: "手机 App 在线可拨状态已预留，当前仍为前端演示。",
        dialing: "拨号中状态为预留效果，后续将展示真实外呼进度。",
        failed: "拨号失败状态已预留，后续可提示检查手机 App 是否在线。",
      };
      return textMap[this.status] || textMap.pending;
    },
  },
  methods: {
    handleClick() {
      if (!this.phone) {
        this.$message.warning("当前没有可拨打的电话号码");
        return;
      }

      const messageMap = {
        pending: {
          type: "info",
          message:
            "当前为拨号功能预留入口，后续将支持：网页点击拨号按钮，已登录手机 App 自动调起拨号。",
        },
        offline: {
          type: "warning",
          message:
            "手机 App 未在线，当前无法发起拨号。后续可通过在线状态联动实现一键外呼。",
        },
        ready: {
          type: "success",
          message:
            "已预留 App 在线可拨状态。当前仍为前端演示，尚未接入真实外呼。",
        },
        dialing: {
          type: "info",
          message: "拨号中状态为预留效果，后续接入手机 App 后将展示真实进度。",
        },
        failed: {
          type: "error",
          message: "拨号失败状态为预留效果，后续将提示检查手机 App 是否在线。",
        },
      };

      const payload = messageMap[this.status] || messageMap.pending;
      this.$message({
        type: payload.type,
        message: payload.message,
        duration: 2600,
      });
      this.$emit("dial-click", { phone: this.phone, status: this.status });
    },
  },
};
</script>

<style scoped>
.crm-phone-field {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
}

.crm-phone-prefix {
  color: #9ca3af;
  font-size: 12px;
  white-space: nowrap;
}

.crm-phone-text {
  color: #1f2937;
  white-space: nowrap;
  line-height: 1.4;
}

.crm-phone-button {
  width: 24px;
  height: 24px;
  border: 1px solid #dbeafe;
  border-radius: 999px;
  background: #f8fbff;
  color: #409eff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 0 0 auto;
}

.crm-phone-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(64, 158, 255, 0.16);
}

.crm-phone-button.is-pending {
  border-color: #dbeafe;
  background: #f8fbff;
  color: #409eff;
}

.crm-phone-button.is-offline {
  border-color: #e5e7eb;
  background: #f3f4f6;
  color: #9ca3af;
}

.crm-phone-button.is-ready {
  border-color: #bbf7d0;
  background: #ecfdf5;
  color: #16a34a;
}

.crm-phone-button.is-dialing {
  border-color: #fed7aa;
  background: #fff7ed;
  color: #ea580c;
}

.crm-phone-button.is-failed {
  border-color: #fecaca;
  background: #fef2f2;
  color: #dc2626;
}
</style>
